import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/learningTheoryResearchPaper'

export default function LearningTheoryWiki() {
  return <ProjectLayout data={data} />
}
